import React, { Fragment } from 'react';
import { Box, Typography, Paper, Button, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Divider } from '@mui/material';
import { SearchIcon, FileTextIcon, WalletIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function Dashboard() {
  const navigate = useNavigate();
  const kpiData = [{
    title: "TODAY'S TRANSACTIONS",
    value: '142',
    valueColor: '#1F2937',
    sub: '↑ 12% vs yesterday',
    badge: null
  }, {
    title: 'PENDING CHECKER APPROVAL',
    value: '7',
    valueColor: '#B38600',
    sub: 'Oldest: 23 mins ago',
    badge: {
      label: 'ACTION REQUIRED',
      color: '#B38600'
    }
  }, {
    title: 'COMPLIANCE HOLDS',
    value: '2',
    valueColor: '#0052CC',
    sub: 'Awaiting backoffice release',
    badge: {
      label: 'UNDER REVIEW',
      color: '#0052CC'
    }
  }, {
    title: 'FLOAT BALANCE',
    value: 'NGN 8,500,000',
    valueColor: '#0B7923',
    sub: 'Threshold: NGN 2,000,000',
    badge: {
      label: 'HEALTHY',
      color: '#0B7923'
    }
  }, {
    title: 'FAILED TODAY',
    value: '3',
    valueColor: '#AE2A19',
    sub: 'Requires investigation',
    badge: {
      label: 'REVIEW',
      color: '#AE2A19'
    }
  }];
  const recentTransactions = [{
    id: 'TXN-LOS-0892',
    sender: 'Amara Diallo',
    beneficiary: 'Abena Mensah',
    amount: '450.00 USD',
    method: 'Cash',
    corridor: 'NG→GH',
    status: 'Completed',
    time: '10:30'
  }, {
    id: 'TXN-LOS-0893',
    sender: 'Kwame Asante',
    beneficiary: 'Yusuf Hassan',
    amount: '800.00 EUR',
    method: 'Bank',
    corridor: 'NG→KE',
    status: 'Pending',
    time: '11:15'
  }, {
    id: 'TXN-LOS-0894',
    sender: 'Fatima Bello',
    beneficiary: 'Ngozi Adeyemi',
    amount: '1,200.00 GBP',
    method: 'Wallet',
    corridor: 'NG→SN',
    status: 'Review',
    time: '12:45'
  }, {
    id: 'TXN-LOS-0895',
    sender: 'Chidi Okonkwo',
    beneficiary: 'Kofi Boateng',
    amount: '300.00 USD',
    method: 'Cash',
    corridor: 'NG→GH',
    status: 'Failed',
    time: '13:20'
  }, {
    id: 'TXN-LOS-0896',
    sender: 'Amara Diallo',
    beneficiary: 'Yusuf Hassan',
    amount: '650.00 EUR',
    method: 'Bank',
    corridor: 'NG→KE',
    status: 'Completed',
    time: '14:10'
  }, {
    id: 'TXN-LOS-0897',
    sender: 'Kwame Asante',
    beneficiary: 'Abena Mensah',
    amount: '500.00 USD',
    method: 'Cash',
    corridor: 'NG→GH',
    status: 'Completed',
    time: '14:55'
  }, {
    id: 'TXN-LOS-0898',
    sender: 'Fatima Bello',
    beneficiary: 'Kofi Boateng',
    amount: '920.00 GBP',
    method: 'Wallet',
    corridor: 'NG→CI',
    status: 'Pending',
    time: '15:30'
  }, {
    id: 'TXN-LOS-0899',
    sender: 'Chidi Okonkwo',
    beneficiary: 'Ngozi Adeyemi',
    amount: '1,100.00 USD',
    method: 'Bank',
    corridor: 'NG→TZ',
    status: 'Completed',
    time: '16:05'
  }];
  const corridorVolumes = [{
    label: 'NG→GH',
    percent: 80,
    amount: 'NGN 28,200,000'
  }, {
    label: 'NG→KE',
    percent: 60,
    amount: 'NGN 21,500,000'
  }, {
    label: 'NG→SN',
    percent: 40,
    amount: 'NGN 9,800,000'
  }, {
    label: 'NG→CI',
    percent: 20,
    amount: 'NGN 4,200,000'
  }];
  const floatSnapshot = [{
    code: 'NGN',
    name: 'Nigerian Naira',
    amount: '8,500,000',
    amountColor: '#0B7923',
    status: 'Healthy',
    statusColor: '#0B7923'
  }, {
    code: 'GHS',
    name: 'Ghanaian Cedi',
    amount: '45,200',
    amountColor: '#0B7923',
    status: 'Healthy',
    statusColor: '#0B7923'
  }, {
    code: 'KES',
    name: 'Kenyan Shilling',
    amount: '620,000',
    amountColor: '#B38600',
    status: 'Warning',
    statusColor: '#B38600'
  }, {
    code: 'XOF',
    name: 'CFA Franc',
    amount: '3,100,000',
    amountColor: '#AE2A19',
    status: 'Critical',
    statusColor: '#AE2A19'
  }];
  const notifications = [{
    dot: '#B38600',
    text: 'Float threshold alert — NGN below 20%',
    time: '10 mins ago'
  }, {
    dot: '#0B7923',
    text: 'TXN-LOS-0892 settled successfully',
    time: '1 hour ago'
  }, {
    dot: '#AE2A19',
    text: 'TXN-LOS-0894 held for compliance review',
    time: '2 hours ago'
  }];
  const getMethodStyle = (method: string) => {
    switch (method) {
      case 'Cash':
        return {
          bg: '#6B7280',
          text: '#FFFFFF',
          border: 'none'
        };
      case 'Bank':
        return {
          bg: 'transparent',
          text: '#0052CC',
          border: '1px solid #0052CC'
        };
      case 'Wallet':
        return {
          bg: 'transparent',
          text: '#0B7923',
          border: '1px solid #0B7923'
        };
      default:
        return {
          bg: '#E5E7EB',
          text: '#374151',
          border: 'none'
        };
    }
  };
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Completed':
        return '#0B7923';
      case 'Pending':
        return '#B38600';
      case 'Failed':
        return '#AE2A19';
      case 'Review':
        return '#0052CC';
      default:
        return '#9CA3AF';
    }
  };
  return <Box sx={{
    p: 3,
    bgcolor: '#F8F9FA',
    minHeight: '100vh'
  }} data-id="element-307">
      {/* KPI ROW */}
      <Box sx={{
      display: 'flex',
      flexDirection: {
        xs: 'column',
        md: 'row'
      },
      gap: '20px',
      mb: '20px'
    }} data-id="element-308">
        {kpiData.map((kpi, index) => <Paper key={index} elevation={0} sx={{
        flex: 1,
        p: '20px',
        borderRadius: '8px',
        border: '1px solid #E5E7EB',
        bgcolor: '#FFFFFF',
        display: 'flex',
        flexDirection: 'column'
      }} data-id="element-309">
            <Typography sx={{
          fontSize: '11px',
          fontWeight: 700,
          color: '#6B7280',
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
          mb: 1.5
        }} data-id="element-310">
              {kpi.title}
            </Typography>
            <Typography sx={{
          fontSize: '28px',
          fontWeight: 700,
          color: kpi.valueColor,
          lineHeight: 1,
          mb: 1
        }} data-id="element-311">
              {kpi.value}
            </Typography>
            <Typography sx={{
          fontSize: '12px',
          color: '#9CA3AF',
          mb: kpi.badge ? 2 : 0
        }} data-id="element-312">
              {kpi.sub}
            </Typography>
            {kpi.badge && <Box sx={{
          mt: 'auto'
        }} data-id="element-313">
                <Chip label={kpi.badge.label} sx={{
            bgcolor: kpi.badge.color,
            color: '#FFFFFF',
            fontSize: '11px',
            fontWeight: 700,
            height: '20px',
            borderRadius: '10px'
          }} data-id="element-314" />
              </Box>}
          </Paper>)}
      </Box>

      {/* MAIN LAYOUT */}
      <Box sx={{
      display: 'flex',
      flexDirection: {
        xs: 'column',
        lg: 'row'
      },
      gap: '20px'
    }} data-id="element-315">
        {/* LEFT COLUMN */}
        <Box sx={{
        flex: '0 0 52%',
        display: 'flex',
        flexDirection: 'column'
      }} data-id="element-316">
          <Paper elevation={0} sx={{
          p: '20px',
          borderRadius: '8px',
          border: '1px solid #E5E7EB',
          bgcolor: '#FFFFFF',
          flexGrow: 1
        }} data-id="element-317">
            <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2
          }} data-id="element-318">
              <Typography sx={{
              fontSize: '12px',
              fontWeight: 700,
              color: '#6B7280',
              letterSpacing: '0.06em',
              textTransform: 'uppercase'
            }} data-id="element-319">
                RECENT TRANSACTIONS
              </Typography>
              <Typography onClick={() => navigate('/history')} sx={{
              fontSize: '13px',
              color: '#0052CC',
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline'
              }
            }} data-id="element-320">
                View All →
              </Typography>
            </Box>
            <TableContainer data-id="element-321">
              <Table sx={{
              minWidth: 650
            }} data-id="element-322">
                <TableHead data-id="element-323">
                  <TableRow data-id="element-324">
                    {['Txn ID', 'Sender', 'Beneficiary', 'Send Amount', 'Payout Method', 'Corridor', 'Status', 'Time'].map(head => <TableCell key={head} sx={{
                    fontSize: '12px',
                    fontWeight: 700,
                    color: '#6B7280',
                    borderBottom: '1px solid #F3F5F7',
                    p: '12px 8px'
                  }} data-id="element-325">
                        {head}
                      </TableCell>)}
                  </TableRow>
                </TableHead>
                <TableBody data-id="element-326">
                  {recentTransactions.map(row => {
                  const methodStyle = getMethodStyle(row.method);
                  return <TableRow key={row.id} sx={{
                    height: '44px'
                  }} data-id="element-327">
                        <TableCell sx={{
                      borderBottom: '1px solid #F3F5F7',
                      p: '8px'
                    }} data-id="element-328">
                          <Typography sx={{
                        fontSize: '11px',
                        fontFamily: 'monospace',
                        color: '#6B7280',
                        cursor: 'pointer',
                        '&:hover': {
                          color: '#0052CC',
                          textDecoration: 'underline'
                        }
                      }} data-id="element-329">
                            {row.id}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{
                      borderBottom: '1px solid #F3F5F7',
                      p: '8px',
                      fontSize: '13px',
                      color: '#1F2937'
                    }} data-id="element-330">
                          {row.sender}
                        </TableCell>
                        <TableCell sx={{
                      borderBottom: '1px solid #F3F5F7',
                      p: '8px',
                      fontSize: '13px',
                      color: '#1F2937'
                    }} data-id="element-331">
                          {row.beneficiary}
                        </TableCell>
                        <TableCell sx={{
                      borderBottom: '1px solid #F3F5F7',
                      p: '8px',
                      fontSize: '13px',
                      color: '#1F2937'
                    }} data-id="element-332">
                          {row.amount}
                        </TableCell>
                        <TableCell sx={{
                      borderBottom: '1px solid #F3F5F7',
                      p: '8px'
                    }} data-id="element-333">
                          <Chip label={row.method} sx={{
                        bgcolor: methodStyle.bg,
                        color: methodStyle.text,
                        border: methodStyle.border,
                        fontSize: '11px',
                        fontWeight: 700,
                        height: '20px',
                        borderRadius: '10px'
                      }} data-id="element-334" />
                        </TableCell>
                        <TableCell sx={{
                      borderBottom: '1px solid #F3F5F7',
                      p: '8px'
                    }} data-id="element-335">
                          <Chip label={row.corridor} sx={{
                        bgcolor: '#F3F4F6',
                        color: '#6B7280',
                        fontSize: '11px',
                        fontWeight: 700,
                        height: '20px',
                        borderRadius: '10px'
                      }} data-id="element-336" />
                        </TableCell>
                        <TableCell sx={{
                      borderBottom: '1px solid #F3F5F7',
                      p: '8px'
                    }} data-id="element-337">
                          <Chip label={row.status} sx={{
                        bgcolor: getStatusColor(row.status),
                        color: '#FFFFFF',
                        fontSize: '11px',
                        fontWeight: 700,
                        height: '20px',
                        borderRadius: '10px'
                      }} data-id="element-338" />
                        </TableCell>
                        <TableCell sx={{
                      borderBottom: '1px solid #F3F5F7',
                      p: '8px',
                      fontSize: '13px',
                      color: '#6B7280'
                    }} data-id="element-339">
                          {row.time}
                        </TableCell>
                      </TableRow>;
                })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>

        {/* CENTER COLUMN */}
        <Box sx={{
        flex: '0 0 24%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }} data-id="element-340">
          {/* MAKER INBOX SUMMARY */}
          <Paper elevation={0} sx={{
          p: '20px',
          borderRadius: '8px',
          border: '1px solid #E5E7EB',
          bgcolor: '#FFFFFF'
        }} data-id="element-341">
            <Typography sx={{
            fontSize: '12px',
            fontWeight: 700,
            color: '#6B7280',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            mb: 3
          }} data-id="element-342">
              MAKER INBOX SUMMARY
            </Typography>
            <Box sx={{
            textAlign: 'center',
            mb: 3
          }} data-id="element-343">
              <Typography sx={{
              fontSize: '32px',
              fontWeight: 700,
              color: '#B38600',
              lineHeight: 1,
              mb: 0.5
            }} data-id="element-344">
                7
              </Typography>
              <Typography sx={{
              fontSize: '13px',
              color: '#6B7280',
              mb: 1
            }} data-id="element-345">
                transactions pending
              </Typography>
              <Typography sx={{
              fontSize: '12px',
              color: '#374151'
            }} data-id="element-346">
                Oldest pending: TXN-LOS-0893 — 23 mins
              </Typography>
            </Box>
            <Button variant="outlined" fullWidth onClick={() => navigate('/maker-inbox')} sx={{
            color: '#374151',
            borderColor: '#E5E7EB',
            textTransform: 'none',
            fontSize: '13px'
          }} data-id="element-347">
              Go to Maker Inbox →
            </Button>
          </Paper>

          {/* COMPLIANCE STATUS */}
          <Paper elevation={0} sx={{
          p: '20px',
          borderRadius: '8px',
          border: '1px solid #E5E7EB',
          bgcolor: '#FFFFFF'
        }} data-id="element-348">
            <Typography sx={{
            fontSize: '12px',
            fontWeight: 700,
            color: '#6B7280',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            mb: 2
          }} data-id="element-349">
              COMPLIANCE STATUS
            </Typography>
            <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 1.5
          }} data-id="element-350">
              <Typography sx={{
              fontSize: '13px',
              color: '#374151'
            }} data-id="element-351">
                Sanctions Screening
              </Typography>
              <Chip label="Operational ✓" sx={{
              bgcolor: '#0B7923',
              color: '#FFFFFF',
              fontSize: '11px',
              fontWeight: 700,
              height: '20px'
            }} data-id="element-352" />
            </Box>
            <Divider sx={{
            borderColor: '#F3F5F7'
          }} data-id="element-353" />
            <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 1.5
          }} data-id="element-354">
              <Typography sx={{
              fontSize: '13px',
              color: '#374151'
            }} data-id="element-355">
                AML Monitoring
              </Typography>
              <Chip label="Operational ✓" sx={{
              bgcolor: '#0B7923',
              color: '#FFFFFF',
              fontSize: '11px',
              fontWeight: 700,
              height: '20px'
            }} data-id="element-356" />
            </Box>
            <Divider sx={{
            borderColor: '#F3F5F7'
          }} data-id="element-357" />
            <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 1.5
          }} data-id="element-358">
              <Typography sx={{
              fontSize: '13px',
              color: '#374151'
            }} data-id="element-359">
                KYC Verification
              </Typography>
              <Chip label="1 Expiring" sx={{
              bgcolor: '#B38600',
              color: '#FFFFFF',
              fontSize: '11px',
              fontWeight: 700,
              height: '20px'
            }} data-id="element-360" />
            </Box>
            <Typography sx={{
            fontSize: '11px',
            color: '#9CA3AF',
            mt: 2
          }} data-id="element-361">
              Last checked: 16:05 UTC
            </Typography>
          </Paper>

          {/* TODAY'S CORRIDOR VOLUME */}
          <Paper elevation={0} sx={{
          p: '20px',
          borderRadius: '8px',
          border: '1px solid #E5E7EB',
          bgcolor: '#FFFFFF'
        }} data-id="element-362">
            <Typography sx={{
            fontSize: '12px',
            fontWeight: 700,
            color: '#6B7280',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            mb: 3
          }} data-id="element-363">
              TODAY'S CORRIDOR VOLUME
            </Typography>
            <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }} data-id="element-364">
              {corridorVolumes.map(item => <Box key={item.label} sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2
            }} data-id="element-365">
                  <Typography sx={{
                fontSize: '13px',
                color: '#374151',
                width: '50px',
                flexShrink: 0
              }} data-id="element-366">
                    {item.label}
                  </Typography>
                  <Box sx={{
                flexGrow: 1,
                height: '6px',
                bgcolor: '#E5E7EB',
                borderRadius: '3px',
                overflow: 'hidden'
              }} data-id="element-367">
                    <Box sx={{
                  width: `${item.percent}%`,
                  height: '100%',
                  bgcolor: '#0052CC'
                }} data-id="element-368" />
                  </Box>
                  <Typography sx={{
                fontSize: '12px',
                color: '#6B7280',
                width: '90px',
                textAlign: 'right',
                flexShrink: 0
              }} data-id="element-369">
                    {item.amount}
                  </Typography>
                </Box>)}
            </Box>
          </Paper>
        </Box>

        {/* RIGHT COLUMN */}
        <Box sx={{
        flex: '0 0 24%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
      }} data-id="element-370">
          {/* QUICK ACTIONS */}
          <Paper elevation={0} sx={{
          p: '20px',
          borderRadius: '8px',
          border: '1px solid #E5E7EB',
          bgcolor: '#FFFFFF'
        }} data-id="element-371">
            <Typography sx={{
            fontSize: '12px',
            fontWeight: 700,
            color: '#6B7280',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            mb: 2
          }} data-id="element-372">
              QUICK ACTIONS
            </Typography>
            <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }} data-id="element-373">
              <Button variant="contained" fullWidth onClick={() => navigate('/transaction-lookup')} sx={{
              bgcolor: '#0052CC',
              '&:hover': {
                bgcolor: '#003DA8'
              },
              justifyContent: 'flex-start',
              textTransform: 'none',
              fontSize: '13px'
            }} data-id="element-374">
                🔍 Transaction Lookup
              </Button>
              <Button variant="outlined" fullWidth onClick={() => navigate('/reports')} sx={{
              color: '#374151',
              borderColor: '#E5E7EB',
              justifyContent: 'flex-start',
              textTransform: 'none',
              fontSize: '13px'
            }} data-id="element-375">
                📄 Generate Reports
              </Button>
              <Button variant="outlined" fullWidth onClick={() => navigate('/float-balance')} sx={{
              color: '#374151',
              borderColor: '#E5E7EB',
              justifyContent: 'flex-start',
              textTransform: 'none',
              fontSize: '13px'
            }} data-id="element-376">
                💰 Float Top-Up Request
              </Button>
            </Box>
          </Paper>

          {/* FLOAT SNAPSHOT */}
          <Paper elevation={0} sx={{
          p: '20px',
          borderRadius: '8px',
          border: '1px solid #E5E7EB',
          bgcolor: '#FFFFFF'
        }} data-id="element-377">
            <Typography sx={{
            fontSize: '12px',
            fontWeight: 700,
            color: '#6B7280',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            mb: 2
          }} data-id="element-378">
              FLOAT SNAPSHOT
            </Typography>
            {floatSnapshot.map((item, index) => <Fragment key={item.code} data-id="element-379">
                <Box sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              py: 1.5
            }} data-id="element-380">
                  <Box data-id="element-381">
                    <Typography sx={{
                  fontSize: '13px',
                  fontWeight: 700,
                  color: '#1F2937'
                }} data-id="element-382">
                      {item.code}
                    </Typography>
                    <Typography sx={{
                  fontSize: '11px',
                  color: '#9CA3AF'
                }} data-id="element-383">
                      {item.name}
                    </Typography>
                  </Box>
                  <Typography sx={{
                fontSize: '13px',
                color: item.amountColor
              }} data-id="element-384">
                    {item.amount}
                  </Typography>
                  <Chip label={item.status} sx={{
                bgcolor: item.statusColor,
                color: '#FFFFFF',
                fontSize: '11px',
                fontWeight: 700,
                height: '20px'
              }} data-id="element-385" />
                </Box>
                {index < floatSnapshot.length - 1 && <Divider sx={{
              borderColor: '#F3F5F7'
            }} data-id="element-386" />}
              </Fragment>)}
            <Typography onClick={() => navigate('/float-balance')} sx={{
            fontSize: '12px',
            color: '#0052CC',
            mt: 2,
            cursor: 'pointer',
            '&:hover': {
              textDecoration: 'underline'
            }
          }} data-id="element-387">
              View Full Float Details →
            </Typography>
          </Paper>

          {/* NOTIFICATIONS */}
          <Paper elevation={0} sx={{
          p: '20px',
          borderRadius: '8px',
          border: '1px solid #E5E7EB',
          bgcolor: '#FFFFFF'
        }} data-id="element-388">
            <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2
          }} data-id="element-389">
              <Typography sx={{
              fontSize: '12px',
              fontWeight: 700,
              color: '#6B7280',
              letterSpacing: '0.06em',
              textTransform: 'uppercase'
            }} data-id="element-390">
                NOTIFICATIONS
              </Typography>
              <Typography onClick={() => navigate('/notifications')} sx={{
              fontSize: '12px',
              color: '#0052CC',
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline'
              }
            }} data-id="element-391">
                View All →
              </Typography>
            </Box>
            {notifications.map((notif, index) => <Fragment key={index} data-id="element-392">
                <Box sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1.5,
              py: 1.5
            }} data-id="element-393">
                  <Box sx={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                bgcolor: notif.dot,
                mt: '6px',
                flexShrink: 0
              }} data-id="element-394" />
                  <Box sx={{
                flexGrow: 1
              }} data-id="element-395">
                    <Typography sx={{
                  fontSize: '13px',
                  color: '#374151',
                  lineHeight: 1.4
                }} data-id="element-396">
                      {notif.text}
                    </Typography>
                  </Box>
                  <Typography sx={{
                fontSize: '11px',
                color: '#9CA3AF',
                flexShrink: 0,
                mt: '2px'
              }} data-id="element-397">
                    {notif.time}
                  </Typography>
                </Box>
                {index < notifications.length - 1 && <Divider sx={{
              borderColor: '#F3F5F7'
            }} data-id="element-398" />}
              </Fragment>)}
          </Paper>
        </Box>
      </Box>
    </Box>;
}